var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHouseAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.856 54.674h-6.464V32.276l3.402 3.407c.51.51 1.19.766 1.786.766.595 0 1.276-.255 1.786-.766 1.02-1.022 1.02-2.64 0-3.577l-7.4-7.41c-.084-.17-.255-.34-.34-.51L34.531 7.068c-1.02-1.021-2.551-1.021-3.572 0-.17.086-.425.256-.596.426L5.7 32.191c-1.021 1.022-1.021 2.64 0 3.577.51.51 1.19.766 1.786.766.595 0 1.275-.255 1.786-.766l3.912-3.918V54.76H7.144c-.595 0-1.02.51-1.02 1.022v2.044c0 .596.51 1.021 1.02 1.021h51.712c.595 0 1.02-.51 1.02-1.021V55.78c.086-.596-.425-1.107-1.02-1.107zm-11.567 0h-9.781c.085-.17.085-.426.085-.682V44.88c0-1.192-1.02-2.214-2.211-2.214h-4.763c-1.191 0-2.212 1.022-2.212 2.214v9.112c0 .256.085.426.085.682H18.456V26.826L32.66 12.604l14.629 14.648v27.422zM28.407 27.337v4.343c0 1.192 1.021 2.214 2.212 2.214h4.848c1.19 0 2.211-1.022 2.211-2.214v-4.343c0-1.192-1.02-2.214-2.211-2.214h-4.848a2.197 2.197 0 00-2.212 2.214z",
    fill: "current"
  })));
}

export default SvgIconHouseAlt;